var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.99999L7.91303 7.91695C10.4616 9.361 11.5384 9.361 14.087 7.91695L21 3.99999M8.09882 1.53653C10.0393 1.48778 11.9607 1.48778 13.9012 1.53654C17.0497 1.61565 18.6239 1.6552 19.7551 2.79063C20.8862 3.92606 20.9189 5.45883 20.9842 8.52436C21.0053 9.51005 21.0053 10.4899 20.9842 11.4756C20.9189 14.5411 20.8862 16.0739 19.7551 17.2093C18.6239 18.3448 17.0497 18.3843 13.9012 18.4634C11.9607 18.5122 10.0393 18.5122 8.09883 18.4634C4.95033 18.3843 3.37608 18.3448 2.24496 17.2093C1.11383 16.0739 1.08114 14.5411 1.01577 11.4756C0.994745 10.4899 0.994745 9.51004 1.01576 8.52435C1.08114 5.45882 1.11382 3.92605 2.24495 2.79062C3.37608 1.65518 4.95033 1.61563 8.09882 1.53653Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.64cd4f96b6cb52a3cc9ea8eb488477d3.svg";
export { ForwardRef as ReactComponent };